<div class="register-wrap" *ngIf="socialsProvidersInit">

    <!-- <div class="additional-box" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
        <p>{{ moduleAuthTexts.already_have_an_account ? moduleAuthTexts.already_have_an_account : 'Already have an account?' }}</p>
        <span class="cursor" (click)="changeScreen('login')" >
            {{ moduleAuthTexts.click_here_to_login ? moduleAuthTexts.click_here_to_login : 'Click here to log in' }}
        </span>
    </div> -->

    <div class="slider-box d-md-block d-lg-none" *ngIf="sliderData && sliderData.length">
        <serviceos-ng-carousel-slider [carouselData]="sliderData" [showNavigationArrows]="false" [isFullWidth]="true"></serviceos-ng-carousel-slider>
    </div>

    <serviceos-ng-alert class="error-alert" *ngIf="formErrorMessage" [type]="'error'">
        {{ formErrorMessage }}
    </serviceos-ng-alert>

    <div class="social-providers-holder" *ngIf="socialProviders?.length">
        <ul class="social-list" >
            <li class="social-item" *ngFor="let social of socialProviders; let i = index">

                <div class="divider-line" *ngIf="social?.type === 'Email' && i === socialProviders.length - 1 && socialProviders.length > 1">
                    <span *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.word_or ? moduleAuthTexts.word_or : 'or'}}</span>
                </div>

                <div class="register-form-wrapper" *ngIf="social?.type === 'Email'">
                    <div class="register-form-holder">
                        <serviceos-ng-local-loader [showLoader]="showLocalLoader"></serviceos-ng-local-loader>
                        <form [formGroup]="registerForm" (ngSubmit)="validateForm()" #templateRForm="ngForm" *ngIf="registerForm">
                            <div class="form-fields-holder" [ngClass]="{'expand' : emailFormExpand}">
                                <div class="input-holder">
                                    <serviceos-ng-form-field>
                                        <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.first_name_field_label ? moduleAuthTexts.first_name_field_label : componentSettings?.details?.fields?.first_name?.label }}</serviceos-ng-label>
                                        <input
                                        [serviceosNgInput]="first_name?.value"
                                        [error]="
                                            first_name?.invalid && formSubmitted"
                                            type="text"
                                            id="first_name"
                                            name="first_name"
                                            formControlName="first_name"
                                        />
                                        <serviceos-ng-error-message *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.first_name_field_error ? moduleAuthTexts.first_name_field_error : componentSettings?.details?.fields?.first_name?.errMsg }}</serviceos-ng-error-message>
                                    </serviceos-ng-form-field>
                                </div>
                                <div class="input-holder">
                                    <serviceos-ng-form-field>
                                        <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.last_name_field_label ? moduleAuthTexts.last_name_field_label : componentSettings?.details?.fields?.last_name?.label }}</serviceos-ng-label>
                                        <input
                                            [serviceosNgInput]="last_name?.value"
                                            [error]="
                                            last_name?.invalid && formSubmitted"
                                            type="text"
                                            id="last_name"
                                            name="last_name"
                                            formControlName="last_name"
                                            />
                                            <serviceos-ng-error-message *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.last_name_field_error ? moduleAuthTexts.last_name_field_error : componentSettings?.details?.fields?.last_name?.errMsg }}</serviceos-ng-error-message>
                                        </serviceos-ng-form-field>
                                    </div>
                                    <div class="input-holder" *ngIf="birthdateFormFieldEnabled">
                                    <serviceos-ng-form-field>
                                        <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.birthday_field_label ? moduleAuthTexts.birthday_field_label : componentSettings?.details?.fields?.birth_date?.label }}</serviceos-ng-label>
                                        <input
                                            [serviceosNgInput]="birth_date?.value"
                                            [error]="
                                            birth_date?.invalid && formSubmitted"
                                            type="text"
                                            id="birth_date"
                                            name="birth_date"
                                            formControlName="birth_date"
                                            />
                                            <serviceos-ng-error-message *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.birthday_field_error ? moduleAuthTexts.birthday_field_error : componentSettings?.details?.fields?.birth_date?.errMsg }}</serviceos-ng-error-message>
                                        </serviceos-ng-form-field>
                                    </div>
                                    <div class="input-holder phone-field-holder">
                                        <ngx-intl-tel-input
                                        [cssClass]="'phone-field'"
                                        [preferredCountries]="preferredCountries"
                                        [enableAutoCountrySelect]="true"
                                        [enablePlaceholder]="true"
                                        [customPlaceholder]="customPlaceholder"
                                        [searchCountryFlag]="true"
                                        [searchCountryField]="[
                                        SearchCountryField.Iso2,
                                        SearchCountryField.Name
                                        ]"
                                        [selectFirstCountry]="false"
                                        [selectedCountryISO]="selectedCountry"
                                        [maxLength]="15"
                                        [phoneValidation]="true"
                                        [separateDialCode]="separateDialCode"
                                        name="phone"
                                        formControlName="phone"
                                    >
                                    </ngx-intl-tel-input>
                                    <serviceos-ng-form-field>
                                            
                                            <serviceos-ng-error-message *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.phone_field_error ? moduleAuthTexts.phone_field_error : componentSettings?.details?.fields?.phone?.errMsg }}</serviceos-ng-error-message>
                                    </serviceos-ng-form-field>
                                </div>
                                
                                <div class="input-holder">
                                    <serviceos-ng-form-field>
                                        <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.email_field_label ? moduleAuthTexts.email_field_label : componentSettings?.details?.fields?.email?.label }}</serviceos-ng-label>
                                        <input
                                        [serviceosNgInput]="email?.value"
                                        [error]="
                                        email?.invalid && formSubmitted"
                                        type="text"
                                            id="email"
                                            name="email"
                                            formControlName="email"
                                            autocomplete="username"
                                        />
                                        <serviceos-ng-error-message *ngIf="email?.errors?.email && email?.value?.length">
                                            <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.email_field_error ? moduleAuthTexts.email_field_error : componentSettings?.details?.fields?.email?.errMsgs?.format }}</ng-container>
                                        </serviceos-ng-error-message>
                                        <serviceos-ng-error-message *ngIf="!(email?.errors?.email && email?.value?.length)">
                                            <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.email_field_error ? moduleAuthTexts.email_field_error : componentSettings?.details?.fields?.email?.errMsgs?.required }}</ng-container>
                                        </serviceos-ng-error-message>
                                    </serviceos-ng-form-field>
                                </div>
                
                                <div class="input-holder">
                                    <div formGroupName="passwordGroup">
                                        <serviceos-ng-form-field>
                                            <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.password_field_label ? moduleAuthTexts.password_field_label : componentSettings?.details?.fields?.password?.label }}</serviceos-ng-label>
                                            <input
                                                [serviceosNgInput]="password?.value"
                                                [error]="
                                                password?.invalid && formSubmitted"
                                                type="password"
                                                id="password"
                                                name="password"
                                                formControlName="password"
                                                autocomplete="current-password"
                                            />
                                            <serviceos-ng-error-message *ngIf="password?.errors?.minlength && !password?.errors?.required">
                                                <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.password_field_error ? moduleAuthTexts.password_field_error : componentSettings?.details?.fields?.password?.errMsgs?.format }}</ng-container>
                                            </serviceos-ng-error-message>
                                            <serviceos-ng-error-message *ngIf="!(password?.errors?.minlength && !password?.errors?.required)">
                                                <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.password_field_error ? moduleAuthTexts.password_field_error : componentSettings?.details?.fields?.password?.errMsgs?.required }}</ng-container>
                                            </serviceos-ng-error-message>
                                        </serviceos-ng-form-field>
                                        <span
                                            class="obf-check"
                                            (click)="
                                                componentSettings.details.fields.password.showPassword = !componentSettings.details.fields.password
                                                    .showPassword
                                            "
                                        >
                                            <i
                                                class="obf-icon icon-si-eye"
                                                aria-hidden="true"
                                                *ngIf="componentSettings.details.fields.password.showPassword"
                                            ></i>
                                            <i
                                                class="obf-icon icon-si-crossed-eye"
                                                aria-hidden="true"
                                                *ngIf="!componentSettings.details.fields.password.showPassword"
                                            ></i>
                                        </span>
                                    </div>
                                </div>
                
                                <div class="input-holder referral-holder" *ngIf="isReferralEnabled">
                                    <div
                                        class="label"
                                        [attr.data-e2e]="'showReferral'"
                                        (click)="showReferral = !showReferral"
                                        [ngClass]="{ 'open': showReferral }"
                                        >
                                        <span class="obf-icon icon-si-plus"></span>
                                        <span class="title" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                                            {{ moduleAuthTexts.add_referral_label ? moduleAuthTexts.add_referral_label : 'Add referral code' }}
                                        </span>
                                    </div>
                
                                    <div class="referral-box">
                                        <serviceos-ng-form-field>
                                            <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.referral_field_label ? moduleAuthTexts.referral_field_label : componentSettings?.details?.fields?.referralCodeField?.label }}</serviceos-ng-label>
                                            <input
                                                [serviceosNgInput]="referralCodeField?.value"
                                                [error]="
                                                referralCodeField?.invalid && formSubmitted"
                                                type="text"
                                                id="referralCodeField"
                                                name="referralCodeField"
                                                formControlName="referralCodeField"
                                            />
                                            <serviceos-ng-error-message *ngIf="referralCodeField?.errors?.referralCodeField && referralCodeField?.value?.length">
                                                <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                                                    {{ moduleAuthTexts.referral_field_error ? moduleAuthTexts.referral_field_error : componentSettings?.details?.fields?.referralCodeField?.errMsg }}
                                                </ng-container>
                                            </serviceos-ng-error-message>
                                        </serviceos-ng-form-field>
                                    </div>
                                </div>
                
                                <div
                                    class="obf-fs-input-wrap obf-accept-privacy"
                                    *ngIf="
                                    privacy_policy_url$
                                            | async as privacy_policy_url
                                    "
                                    [ngClass]="{ 'obf-error': terms?.errors?.required && formSubmitted }"
                                >
                                    <div class="obf-fs-check-inputs ">
                                        <input id="terms" name="terms" type="checkbox" formControlName="terms" />
                                        <label for="terms" [attr.data-e2e]="'terms-checkbox'">
                                            <span class="obf-checkbox icon-si-check"></span>
                                            <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                                                <span class="terms-html-holder" *ngIf="moduleAuthTexts.terms_field_html" [innerHTML]="moduleAuthTexts.terms_field_html"></span>
                                                <ng-container *ngIf="!moduleAuthTexts.terms_field_html">
                                                    <span class="obf-terms-text-holder" *ngIf="
                                                        terms_and_conditions_url$
                                                            | async as terms_and_conditions_url
                                                    ">
                                                        <span>I have read and agree with&nbsp;</span><span *ngIf="brandName$ | async as brandName">{{ brandName }}</span>'
                                                        <a
                                                            href="{{ privacy_policy_url }}"
                                                            target="_blank"
                                                            rel="noopener noreferrer">
                                                            &nbsp;Privacy Policy&nbsp;</a>
                                                            <span>and</span>&nbsp;
                                                        <a
                                                            href="{{ terms_and_conditions_url }}"
                                                            target="_blank"
                                                            rel="noopener noreferrer">
                                                            Terms & Conditions
                                                        </a>.
                                                    </span>
                                                </ng-container>
                                                
                                            </ng-container>
                                                
                                        </label>
                                    </div>
                                    <serviceos-ng-error-message *ngIf="terms?.errors?.required && formSubmitted">
                                        <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                                            {{ moduleAuthTexts.terms_field_error ? moduleAuthTexts.terms_field_error : componentSettings?.details?.fields?.terms?.errMsg }}
                                        </ng-container>
                                    </serviceos-ng-error-message>
                                    <!-- <small class="obf-fs-error">{{ componentSettings?.details?.fields?.terms?.errMsg }} </small> -->
                                </div>
                
                                <div class="obf-fs-input-wrap updates-way">
                                    <div class="obf-checkbox-optimal-description" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.optimal_field_desc ? moduleAuthTexts.optimal_field_desc : 'I want to receive updates about promotions, coupons, surveys and news via: (optional) '}}</div>
                
                                    <div class="obf-email">
                                        <div class="obf-fs-check-inputs">
                                            <input id="emailOptIn"  name="emailOptIn" type="checkbox" formControlName="emailOptIn" />
                                            <label for="emailOptIn" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                                                <span class="obf-checkbox icon-si-check"></span>
                                                {{ moduleAuthTexts.mail_opt_field_label ? moduleAuthTexts.mail_opt_field_label : componentSettings?.details?.fields?.emailOptIn?.label }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="obf-sms">
                                        <div class="obf-fs-check-inputs ">
                                            <input id="smsOptIn" name="smsOptIn" type="checkbox" formControlName="smsOptIn" />
                                            <label for="smsOptIn" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                                                <span class="obf-checkbox icon-si-check"></span>
                                                {{ moduleAuthTexts.sms_opt_field_label ? moduleAuthTexts.sms_opt_field_label : componentSettings?.details?.fields?.smsOptIn?.label }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <serviceos-ng-button
                                    id="register-button-component"
                                    [isSubmitButton]="true"
                                    [type]="'primary'"
                                    [isFullWidth]="true"
                                    *ngIf="moduleAuthTexts$ | async as moduleAuthTexts"
                                    >
                                    {{ moduleAuthTexts.sign_up_label ? moduleAuthTexts.sign_up_label : componentSettings?.details?.fields?.signUp?.label }}
                                </serviceos-ng-button>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="divider-line after" *ngIf="social?.type === 'Email' && i === 0 && socialProviders.length > 1">
                    <span *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.word_or ? moduleAuthTexts.word_or : 'or'}}</span>
                </div>

                <serviceos-ng-button
                    *ngIf="social.type !== 'Email'"
                    (click)="loginSocial(social)"
                    [isFullWidth]="true"
                    [socialAction]="'register'"
                    [type]="social.type"
                    >
                </serviceos-ng-button>
            </li>
        </ul>
        
        <div class="divider-line" *ngIf="socialProviders.length && !hasEmailSocialLogin()">
            <span *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.word_or ? moduleAuthTexts.word_or : 'or'}}</span>
        </div>
    </div>
    <div class="register-form-holder" *ngIf="!hasEmailSocialLogin()">
        <serviceos-ng-local-loader [showLoader]="showLocalLoader"></serviceos-ng-local-loader>
        <form [formGroup]="registerForm" (ngSubmit)="validateForm()" #templateRForm="ngForm" *ngIf="registerForm">
            <div class="form-fields-holder" [ngClass]="{'expand' : isFormExpand}">
                <div class="input-holder">
                    <serviceos-ng-form-field>
                        <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.first_name_field_label ? moduleAuthTexts.first_name_field_label : componentSettings?.details?.fields?.first_name?.label }}</serviceos-ng-label>
                        <input
                        [serviceosNgInput]="first_name?.value"
                        [error]="
                            first_name?.invalid && formSubmitted"
                            type="text"
                            id="first_name"
                            name="first_name"
                            formControlName="first_name"
                        />
                        <serviceos-ng-error-message *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.first_name_field_error ? moduleAuthTexts.first_name_field_error : componentSettings?.details?.fields?.first_name?.errMsg }}</serviceos-ng-error-message>
                    </serviceos-ng-form-field>
                </div>
                <div class="input-holder">
                    <serviceos-ng-form-field>
                        <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.last_name_field_label ? moduleAuthTexts.last_name_field_label : componentSettings?.details?.fields?.last_name?.label }}</serviceos-ng-label>
                        <input
                            [serviceosNgInput]="last_name?.value"
                            [error]="
                            last_name?.invalid && formSubmitted"
                            type="text"
                            id="last_name"
                            name="last_name"
                            formControlName="last_name"
                            />
                            <serviceos-ng-error-message *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.last_name_field_error ? moduleAuthTexts.last_name_field_error : componentSettings?.details?.fields?.last_name?.errMsg }}</serviceos-ng-error-message>
                        </serviceos-ng-form-field>
                    </div>
                    <div class="input-holder" *ngIf="birthdateFormFieldEnabled">
                    <serviceos-ng-form-field>
                        <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.birthday_field_label ? moduleAuthTexts.birthday_field_label : componentSettings?.details?.fields?.birth_date?.label }}</serviceos-ng-label>
                        <input
                            [serviceosNgInput]="birth_date?.value"
                            [error]="
                            birth_date?.invalid && formSubmitted"
                            type="text"
                            id="birth_date"
                            name="birth_date"
                            formControlName="birth_date"
                            />
                            <serviceos-ng-error-message *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.birthday_field_error ? moduleAuthTexts.birthday_field_error : componentSettings?.details?.fields?.birth_date?.errMsg }}</serviceos-ng-error-message>
                        </serviceos-ng-form-field>
                    </div>
                    <div class="input-holder phone-field-holder">
                        <ngx-intl-tel-input
                        [cssClass]="'phone-field'"
                        [preferredCountries]="preferredCountries"
                        [enableAutoCountrySelect]="true"
                        [enablePlaceholder]="true"
                        [customPlaceholder]="customPlaceholder"
                        [searchCountryFlag]="true"
                        [searchCountryField]="[
                        SearchCountryField.Iso2,
                        SearchCountryField.Name
                        ]"
                        [selectFirstCountry]="false"
                        [selectedCountryISO]="selectedCountry"
                        [maxLength]="15"
                        [phoneValidation]="true"
                        [separateDialCode]="separateDialCode"
                        name="phone"
                        formControlName="phone"
                    >
                    </ngx-intl-tel-input>
                    <serviceos-ng-form-field>
                        <!-- <serviceos-ng-label>{{ componentSettings?.details?.fields?.phone?.label }}</serviceos-ng-label> -->
                        <!-- <input
                            [serviceosNgInput]="phone?.value"
                            [error]="
                            phone?.invalid && formSubmitted"
                            type="text"
                            id="phone"
                            name="phone"
                            formControlName="phone"
                            /> -->
                            
                            <serviceos-ng-error-message *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.phone_field_error ? moduleAuthTexts.phone_field_error : componentSettings?.details?.fields?.phone?.errMsg }}</serviceos-ng-error-message>
                    </serviceos-ng-form-field>
                </div>
                
                <div class="input-holder">
                    <serviceos-ng-form-field>
                        <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.email_field_label ? moduleAuthTexts.email_field_label : componentSettings?.details?.fields?.email?.label }}</serviceos-ng-label>
                        <input
                        [serviceosNgInput]="email?.value"
                        [error]="
                        email?.invalid && formSubmitted"
                        type="text"
                            id="email"
                            name="email"
                            formControlName="email"
                            autocomplete="username"
                        />
                        <serviceos-ng-error-message *ngIf="email?.errors?.email && email?.value?.length">
                            <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.email_field_error ? moduleAuthTexts.email_field_error : componentSettings?.details?.fields?.email?.errMsgs?.format }}</ng-container>
                        </serviceos-ng-error-message>
                        <serviceos-ng-error-message *ngIf="!(email?.errors?.email && email?.value?.length)">
                            <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.email_field_error ? moduleAuthTexts.email_field_error : componentSettings?.details?.fields?.email?.errMsgs?.required }}</ng-container>
                        </serviceos-ng-error-message>
                    </serviceos-ng-form-field>
                </div>

                <div class="input-holder">
                    <div formGroupName="passwordGroup">
                        <serviceos-ng-form-field>
                            <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.password_field_label ? moduleAuthTexts.password_field_label : componentSettings?.details?.fields?.password?.label }}</serviceos-ng-label>
                            <input
                                [serviceosNgInput]="password?.value"
                                [error]="
                                password?.invalid && formSubmitted"
                                type="password"
                                id="password"
                                name="password"
                                formControlName="password"
                                autocomplete="current-password"
                            />
                            <serviceos-ng-error-message *ngIf="password?.errors?.minlength && !password?.errors?.required">
                                <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.password_field_error ? moduleAuthTexts.password_field_error : componentSettings?.details?.fields?.password?.errMsgs?.format }}</ng-container>
                            </serviceos-ng-error-message>
                            <serviceos-ng-error-message *ngIf="!(password?.errors?.minlength && !password?.errors?.required)">
                                <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.password_field_error ? moduleAuthTexts.password_field_error : componentSettings?.details?.fields?.password?.errMsgs?.required }}</ng-container>
                            </serviceos-ng-error-message>
                        </serviceos-ng-form-field>
                        <span
                            class="obf-check"
                            (click)="
                                componentSettings.details.fields.password.showPassword = !componentSettings.details.fields.password
                                    .showPassword
                            "
                        >
                            <i
                                class="obf-icon icon-si-eye"
                                aria-hidden="true"
                                *ngIf="componentSettings.details.fields.password.showPassword"
                            ></i>
                            <i
                                class="obf-icon icon-si-crossed-eye"
                                aria-hidden="true"
                                *ngIf="!componentSettings.details.fields.password.showPassword"
                            ></i>
                        </span>
                    </div>
                </div>

                <div class="input-holder referral-holder" *ngIf="isReferralEnabled">
                    <div
                        class="label"
                        [attr.data-e2e]="'showReferral'"
                        (click)="showReferral = !showReferral"
                        [ngClass]="{ 'open': showReferral }"
                        >
                        <span class="obf-icon icon-si-plus"></span>
                        <span class="title" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                            {{ moduleAuthTexts.add_referral_label ? moduleAuthTexts.add_referral_label : 'Add referral code' }}
                        </span>
                    </div>

                    <div class="referral-box" *ngIf="isReferralEnabled">
                        <serviceos-ng-form-field>
                            <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.referral_field_label ? moduleAuthTexts.referral_field_label : componentSettings?.details?.fields?.referralCodeField?.label }}</serviceos-ng-label>
                            <input
                                [serviceosNgInput]="referralCodeField?.value"
                                [error]="
                                referralCodeField?.invalid && formSubmitted"
                                type="text"
                                id="referralCodeField"
                                name="referralCodeField"
                                formControlName="referralCodeField"
                            />
                            <serviceos-ng-error-message *ngIf="referralCodeField?.errors?.referralCodeField && referralCodeField?.value?.length">
                                <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                                    {{ moduleAuthTexts.referral_field_error ? moduleAuthTexts.referral_field_error : componentSettings?.details?.fields?.referralCodeField?.errMsg }}
                                </ng-container>
                            </serviceos-ng-error-message>
                        </serviceos-ng-form-field>
                    </div>

                    

                    <!-- <div class="obf-promocode-field obf-fs-input-wrap">
                        <div>
                            <input
                                FsFocusHandler
                                [inputScrollParent]="'.obf-lr-modal'"
                                fsTextField
                                [labelText]="componentSettings?.details?.fields?.referralCodeField?.label"
                                [errorMessage]="componentSettings?.details?.fields?.referralCodeField?.errMsg"
                                [error]="referralCodeField.invalid && formSubmitted"
                                type="text"
                                id="referralCodeField"
                                [attr.data-e2e]="'referral'"
                                name="referralCodeField"
                                formControlName="referralCodeField"
                            />
                        </div>
                    </div> -->
                </div>

                <div
                    class="obf-fs-input-wrap obf-accept-privacy"
                    *ngIf="
                    privacy_policy_url$
                            | async as privacy_policy_url
                    "
                    [ngClass]="{ 'obf-error': terms?.errors?.required && formSubmitted }"
                >
                    <div class="obf-fs-check-inputs ">
                        <input id="terms" name="terms" type="checkbox" formControlName="terms" />
                        <label for="terms" [attr.data-e2e]="'terms-checkbox'">
                            <span class="obf-checkbox icon-si-check"></span>
                            <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                                <span class="terms-html-holder" *ngIf="moduleAuthTexts.terms_field_html" [innerHTML]="moduleAuthTexts.terms_field_html"></span>
                                <ng-container *ngIf="!moduleAuthTexts.terms_field_html">
                                    <span class="obf-terms-text-holder" *ngIf="
                                        terms_and_conditions_url$
                                            | async as terms_and_conditions_url
                                    ">
                                        <span>I have read and agree with&nbsp;</span><span *ngIf="brandName$ | async as brandName">{{ brandName }}</span>'
                                        <a
                                            href="{{ privacy_policy_url }}"
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            &nbsp;Privacy Policy&nbsp;</a>
                                            <span>and</span>&nbsp;
                                        <a
                                            href="{{ terms_and_conditions_url }}"
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            Terms & Conditions
                                        </a>.
                                    </span>
                                </ng-container>
                                
                            </ng-container>
                                
                        </label>
                    </div>
                    <serviceos-ng-error-message *ngIf="terms?.errors?.required && formSubmitted">
                        <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                            {{ moduleAuthTexts.terms_field_error ? moduleAuthTexts.terms_field_error : componentSettings?.details?.fields?.terms?.errMsg }}
                        </ng-container>
                    </serviceos-ng-error-message>
                    <!-- <small class="obf-fs-error">{{ componentSettings?.details?.fields?.terms?.errMsg }} </small> -->
                </div>

                <div class="obf-fs-input-wrap updates-way">
                    <div class="obf-checkbox-optimal-description" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.optimal_field_desc ? moduleAuthTexts.optimal_field_desc : 'I want to receive updates about promotions, coupons, surveys and news via: (optional) '}}</div>

                    <div class="obf-email">
                        <div class="obf-fs-check-inputs">
                            <input id="emailOptIn"  name="emailOptIn" type="checkbox" formControlName="emailOptIn" />
                            <label for="emailOptIn" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                                <span class="obf-checkbox icon-si-check"></span>
                                {{ moduleAuthTexts.mail_opt_field_label ? moduleAuthTexts.mail_opt_field_label : componentSettings?.details?.fields?.emailOptIn?.label }}
                            </label>
                        </div>
                    </div>
                    <div class="obf-sms">
                        <div class="obf-fs-check-inputs ">
                            <input id="smsOptIn" name="smsOptIn" type="checkbox" formControlName="smsOptIn" />
                            <label for="smsOptIn" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                                <span class="obf-checkbox icon-si-check"></span>
                                {{ moduleAuthTexts.sms_opt_field_label ? moduleAuthTexts.sms_opt_field_label : componentSettings?.details?.fields?.smsOptIn?.label }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <serviceos-ng-button
                    id="register-button-component"
                    [isSubmitButton]="true"
                    [type]="'primary'"
                    [isFullWidth]="true"
                    *ngIf="moduleAuthTexts$ | async as moduleAuthTexts"
                    >
                    {{ moduleAuthTexts.sign_up_label ? moduleAuthTexts.sign_up_label : componentSettings?.details?.fields?.signUp?.label }}
                </serviceos-ng-button>
            </div>
        </form>
    </div>
</div>

<div class="local-loader-box" *ngIf="!socialsProvidersInit">
    <serviceos-ng-local-loader [showLoader]="true"></serviceos-ng-local-loader>
</div>